import React from "react";
import App from 'pages/module';
import NotFound from "pages/notFound";
import ConfirmOptin from "pages/optin";
import ConfirmUnsubscribed from "pages/unsubscribed";
import Invitation from "pages/invitation";
import { Route, Switch } from "react-router-dom";
import { FollowResize } from "./resize";


export default function RenderRoutes() {
    return (
        <FollowResize>
            <Switch>
                <Route
                    path="/target/optin"
                    render={
                        () => <ConfirmOptin />
                    }
                />
                <Route
                    path="/target/unsubscribe"
                    render={
                        () => <ConfirmUnsubscribed />
                    }
                />
                <Route
                    path="/target/invitation/success"
                    render={
                        () => <Invitation status="success" />
                    }
                />
                <Route
                    path="/target/invitation/failure"
                    render={
                        () => <Invitation status="failure" />
                    }
                />
                <Route
                    exact
                    path="/target"
                    render={
                        () => <App />
                    }
                />
                <Route
                    exact
                    render={
                        () => <NotFound />
                    }
                />
            </Switch>
        </FollowResize>
    );
}
